import { Component, effect } from '@angular/core';
import { UserService } from '../../user.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { UserInfo } from '../../user-info/user-info';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommunityCalendar } from '../community-calendar/community-calendar';
import { PaymentsOverview } from '../payments-overview/payments-overview';
import { MyWorkOrdersComponent } from '../../my-work-orders/my-work-orders.component';
import { PropertyOverviewWidget } from '../property-overview-widget/property-overview-widget';

@Component({
	selector: 'app-home-page',
	imports: [RouterOutlet, RouterLink, RouterLinkActive, FormsModule, CommonModule, UserInfo, CommunityCalendar, PaymentsOverview, MyWorkOrdersComponent, PropertyOverviewWidget],
	templateUrl: './home-page.html',
	styleUrl: './home-page.scss'
})
export class HomePageComponent {


	safeMapUrl: SafeResourceUrl | null = null;

	public Current_balance: number = 20000;
	public Next_Payment_Date : Date = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000);

	public pastPayments = [
		{ date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), amount: 20000 },
		{ date: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000), amount: 20000 },
		{ date: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000), amount: 20000 },
	];


	constructor(protected userService: UserService, protected sanitizer: DomSanitizer) {
		effect(() => {
			const tenant = this.userService.currentTennant();
			this.language = tenant ? tenant.Language : 1;
			
			//const mapUrl = "www.google.com/maps?q=" + this.userService.currentTennant()?.Region + ", " + this.userService.currentTennant()?.City + ", " + this.userService.currentTennant()?.Address + "&output=embed";
			let mapUrl = this.userService.currentTennant()?.Google_map;
			//www.google.com/maps/place/
			if( mapUrl.startsWith('http://') ){
				//remove http://
				mapUrl = mapUrl.replace('http://', '');
			}
			if( mapUrl.startsWith('https://') ){
				//remove https://
				mapUrl = mapUrl.replace('https://', '');
			}
			if (mapUrl.startsWith('www.google.com/maps/place/')) {
				mapUrl = mapUrl.replace('www.google.com/maps/place/', '');
			}

			if (mapUrl) {
				this.safeMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://' + 'www.google.com/maps?q=' + mapUrl + '&output=embed');
			}

		});
	}

	protected language: number = 1;

	contentStrings : Record<string, Record<number, string>> = {
		WelcomeBack: { 1: "Welcome Back", 2: "お帰りなさい" },
		CurrentBalance: { 1: "Current Balance", 2: "現在の残高" },
		NextPaymentDate: { 1: "Next Payment Date", 2: "次の支払日" },
		PastPayments: { 1: "Past Payments", 2: "過去の支払い" },
		MyMCXPortal: { 1: "My MCX Portal", 2: "マイMCXポータル" },
		CommunityCalendar: { 1: "Community Calendar", 2: "コミュニティカレンダー" },
	}

}
